<div *ngIf="false" class="column">
  <app-alert type="error">
    <span class="weight-medium" title>
      {{ 'shared.warning' | translate }}
    </span>
    <div description>
      {{ 'exception-mode.invalid-auth-code' | translate }}
    </div>
  </app-alert>
</div>

<form [formGroup]="exceptionForm" (ngSubmit)="onSubmit()">
  <div class="columns">
    <div class="column">
      <app-input-select
        [form]="exceptionForm"
        inputName="processType"
        [translate]="true"
        [values]="PROCESS_TYPES"
        label="{{ 'exception-mode.process-type-label' | translate }}"
        placeholder="{{ 'exception-mode.process-type-placeholder' | translate }}"
        errorMessage="{{ 'exception-mode.process-type-error-message' | translate }}"
        (changeOption)="onChangeExceptionProcess()"
      ></app-input-select>
    </div>

    <div
      *ngIf="aditionalFieldsConfig?.waiverEnabled && aditionalFieldsVisibleConfig?.waiverVisible"
      class="column"
    >
      <app-input-field
        [form]="exceptionForm"
        type="text"
        inputName="waiver"
        label="{{ 'exception-mode.waiver-label' | translate }}"
        placeholder="{{ 'exception-mode.waiver-placeholder' | translate }}"
        errorMessage="{{ 'exception-mode.waiver-error-message' | translate }}"
      ></app-input-field>
    </div>

    <div
      *ngIf="
        aditionalFieldsConfig?.tourcodeEnabled && aditionalFieldsVisibleConfig?.tourcodeVisible
      "
      class="column"
    >
      <app-input-field
        [form]="exceptionForm"
        type="text"
        inputName="tourCode"
        label="{{ 'exception-mode.tour-code-label' | translate }}"
        placeholder="{{ 'exception-mode.tour-code-placeholder' | translate }}"
        errorMessage="{{ 'exception-mode.tourcode-invalid' | translate }}"
      ></app-input-field>
    </div>
  </div>

  <app-osi
    *ngIf="aditionalFieldsConfig?.osiEnabled && aditionalFieldsVisibleConfig?.osiVisible"
    [formArray]="osis()"
    [formGroup]="exceptionForm"
    (add)="addOsi($event)"
    (delete)="deleteOsi($event)"
  >
  </app-osi>

  <div class="columns">
    <div class="submit-container">
      <app-input-submit
        type="submit"
        [disabled]="!validateForm()"
        inputText="{{ 'exception-mode.modal-submit-exception-mode' | translate }}"
      >
      </app-input-submit>
    </div>
  </div>
</form>
